import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    TabContent,
    TabPane,
    Alert
} from "reactstrap"
import DPAlert from "../../../framework/widgets/DPAlert"
import { Text } from "../../../framework/validators/TextValidation"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//Import DPComponents
import DPNavBar from "../../../framework/widgets/DPNavBar"
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import CashBookSummary from "./CashBookSummary"
import CashbookCreditDebit from "./CashbookCreditDebit"
import CashBookPOSTrading from "./CashBookPOSTrading"
import CashBookPOSVouchers from "./CashBookPOSVouchers"
import CashBookVASCollection from "./CashBookVASCollection"
import CashBookReceipts from "./CashBookReceipts"
import CashBookPayments from "./CashBookPayments"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"
import DPPrintOption from "framework/widgets/DPPrintOptions"
import { saveCashBook, PayModetData, ReasonTypeReceiptsData, ReasonTypePaymentsData, GetLastCashBookDocument } from "./CashBookController"
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from "react"
import { getCashBookData } from "./CashBookController"
import moment from "moment"

const CashBook = props => {



    let currentDate = moment().format("YYYY-MM-DD")

    let history = useHistory();
    var time = process.env.REACT_APP_ALERTTIMEOUT
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    //stateCodes for VenderMasterTab1
    const [strSupplierCode, SetCode] = useState("");

    const [menuCode, SetMenuCode] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [menu, SetMenu] = useState("")
    const [disabled, setDisabled] = useState(false);
    const [AlertShow, setAlertShow] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false);
    const [show, setShow] = useState(false);
    const [AlertMsg, setAlertMsg] = useState('');
    const [AlertColor, setAlertColor] = useState('');
    const [Post, SetPost, getPost] = useState([]);
    const [saveBtnEnable, setSaveEnable] = useState(false);
    const [crEnable, setCrEnable] = useState(false);
    const [paymentCode, setPaymentCode] = useState("")
    const [reasonTypeReceiptsCode, setReasonTypeReceiptsCode] = useState("")
    const [reasonTypePaymentCode, setReasonTypePaymentCode] = useState("")

    const [CashBookDate, SetCashBookDate] = useState("")
    const [cutoffDate, setCutoffDate] = useState("")

    const [rowsSummary, setrowsSummary] = useState([{ id: 1 }])
    const [rowsCreditSummary, setCreditSummary] = useState([{ id: 1 }])
    const [rowsDebitSummary, setDebitSummary] = useState([{ id: 1 }])
    const [rowsPOSTranding, setrowsPOSTranding] = useState([{ id: 1 }])
    const [rowsPOSVoucher, setrowsPOSVoucher] = useState([{ id: 1 }])
    const [rowsVAS, setrowsVAS] = useState([{ id: 1 }])
    const [rowsReceipts, setrowsReceipts] = useState([{ id: 1 }])
    const [rowsPayment, setrowsPayment] = useState([{ id: 1 }])

    const [TotalSummaryValue, setTotalSummaryValue] = useState("0.0")
    const [TotalTrnasactionValue, setTotalTrnasactionValue] = useState("0.0")
    const [TotalPOSTrandingValue, setTotalPOSTrandingValue] = useState("0.0")
    const [TotalPOSVoucherValue, setTotalPOSVoucherValue] = useState("0.0")
    const [TotalVASValue, setTotalVASValue] = useState("0.0")
    const [TotalReceiptsValue, setTotalReceiptsValue] = useState("0.0")
    const [TotalPaymentsValue, setTotalPaymentsValue] = useState("0.0")
    const [TotalCreditSummaryValue, setTotalCreditSummaryValue] = useState("0.0")
    const [TotalDebitSummaryValue, setTotalDebitSummaryValue] = useState("0.0")
    const [TotalCFValue, setTotalCFValue] = useState("0.0")
    const [TotalOpenValue, setTotalOpenValue] = useState("0.0")

    const [addNew, setaddNew] = useState(true)
    //stateCodes for VenderMasterTab3

    //Alert Parameter
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    const [DocumentCode, setDocumentCode] = useState("00000")
    const [lastCashBookDocumentCode, setLastCashBookDocumentCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)

    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [printoptionShow, setprintoptionShow] = useState(false)
    const [PayModeData, setPayModeData] = useState([]);
    const [ReasonTypeData, setReasonTypeData] = useState([]);
    const [PaymentsTypeData, setPaymentsTypeData] = useState([])
    const [handleClear, setHandleClear] = useState(false)
    const tabList = [
        {
            text: "Summary",
            icon: "fas fa-home",
            tabID: "1",
            onClick: () => {
                toggleCustom("1")
            }
        },
        {
            text: "Details",
            icon: "far fa-user",
            tabID: "2",
            onClick: () => {
                toggleCustom("2")
            }
        },
        // {
        //     text: "POS(Vouchers)",
        //     icon: "far fa-user",
        //     tabID: "3",
        //     onClick: () => {
        //         toggleCustom("3")
        //     }
        // },
        {
            text: "VAS Collection",
            icon: "far fa-user",
            tabID: "4",
            onClick: () => {
                toggleCustom("4")
            }
        },
        {
            text: "Cashbook Receipts",
            icon: "far fa-user",
            tabID: "5",
            onClick: () => {
                toggleCustom("5")
            }
        },
        {
            text: "Cashbook Payments",
            icon: "far fa-user",
            tabID: "6",
            onClick: () => {
                toggleCustom("6")
            }
        },
        {
            text: "Credit/Debit Summary",
            icon: "fas fa-home",
            tabID: "7",
            onClick: () => {
                toggleCustom("7")
            }
        },
    ];


    const [cashBookType, setCashBookType] = useState("")
    const [csbList, setCsbList] = useState([])


    const {
        getMenuDetails, masterAuditLog, addtoFavourite
    } = useContext(Context);

    //**Get File Details */
    useEffect(async () => {

        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetMenu(menu)
        SetParentName(parentname)

        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogCompanyCode(CompanyCode)
        setLogUserType(LogUserType)
        var requestOptions = {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            redirect: "follow",
        };

        fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
            .then(response => response.json())
            .then(result => {

                SetMenuAccess(result.data.strMenuAccessRight)
                SetMenuCreate(result.data.strMenuCreateRight)
                SetMenuDelete(result.data.strMenuDeleteRight)
                SetMenuModify(result.data.strMenuModifyRight)
                SetMenuPrint(result.data.strMenuPrintRight)
                SetMenuProcess(result.data.strMenuProcessRight)
                SetMenuName(result.data.strMenuName)
                SetMenuCode(result.data.strMenuTag)

            }).catch(error =>
                console.log('error', error)
            );

        ClearItem()

    }, [])

    /////**************search data from code***********************


    // AuditLog
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push("/dashboard")

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log

        const lastDocumentCode = await GetLastCashBookDocument(LocationCode);
        setLastCashBookDocumentCode(lastDocumentCode);
    }, [])


    const SetCashBookSummary = (cshbookCode) => {
        const authToken = localStorage.getItem("authToken")

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Fetching...")
        //  let modifiedRows = [...arRow]
        fetch(`${ApiURL}CashBook/search/${cshbookCode}/${LocationCode}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
        })
            .then(Response => Response.json())
            .then(responseData => {
                SetLoadingAlert(false)
                if (responseData.success == true) {
                    {

                        const newArray = [...responseData.data]
                        SetPost(newArray)

                        setrowsSummary([])
                        setrowsPOSTranding([])
                        setrowsPOSVoucher([])
                        setrowsVAS([])
                        setrowsReceipts([])
                        setrowsPayment([])
                        setCreditSummary([])
                        setDebitSummary([])
                        setPayModeData([])
                        setReasonTypeData([])
                        setPaymentsTypeData([])

                        SetPost(state => {
                            state.map((localState) => {
                                SetCashBookDate(localState.cashBookDate)
                                let modifiedRowsCreditSummary = []
                                let modifiedRowsDebitSummary = []
                                let modifiedRowsSummary = []
                                let modifiedRowsPOSTrading = []
                                let modifiedRowsPOSVoucher = []
                                let modifiedRowsVASCollection = []
                                let modifiedRowsCashbookReceipts = []
                                let modifiedRowsCashbookPayments = []

                                let LineSummaryAmount = 0
                                let LineCreditSummaryAmount = 0
                                let LineDebitSummaryAmount = 0
                                let LineTransactionTotal = 0
                                let LinePOSTradingAmount = 0
                                let LinePOSVoucherAmount = 0
                                let LineVASCollectionAmount = 0
                                let LineReceivedAmount = 0
                                let LinePaymentAmount = 0

                                // Accessing and setting CutoffDate from response
                                const cutoffDate = responseData.data[0]?.cutoffDate
                                console.log("Cutoff Date:", cutoffDate)
                                setCutoffDate(cutoffDate)

                                localState.m_TBLCashBookCreditSummary.map((localState) => {
                                    modifiedRowsCreditSummary.push({ creditTransaction: localState.transactionName, creditamount: localState.amount })
                                    LineCreditSummaryAmount = parseFloat(LineCreditSummaryAmount) + parseFloat(localState.amount)
                                    setTotalCreditSummaryValue(LineCreditSummaryAmount)
                                })
                                setCreditSummary(modifiedRowsCreditSummary.length == undefined || modifiedRowsCreditSummary.length == 0 ? [{ id: 1 }] : modifiedRowsCreditSummary)


                                localState.m_TBLCashBookDebitSummary.map((localState) => {
                                    modifiedRowsDebitSummary.push({ debitTransaction: localState.transactionName, debitamount: localState.amount })
                                    LineDebitSummaryAmount = parseFloat(LineDebitSummaryAmount) + parseFloat(localState.amount)
                                    setTotalDebitSummaryValue(LineDebitSummaryAmount)
                                })
                                setDebitSummary(modifiedRowsDebitSummary.length == undefined || modifiedRowsDebitSummary.length == 0 ? [{ id: 1 }] : modifiedRowsDebitSummary)

                                setTotalCFValue(LineDebitSummaryAmount - LineCreditSummaryAmount)

                                localState.m_TBLCashBookSummary.map((localState) => {
                                    modifiedRowsSummary.push({ paymentcode: localState.paymentCode, paymentDescription: localState.paymentDescription, amount: localState.amount, noofTran: localState.noofTransactions, state: false })
                                    LineSummaryAmount = parseFloat(LineSummaryAmount) + parseFloat(localState.amount)
                                    setTotalSummaryValue(LineSummaryAmount)
                                    LineTransactionTotal = parseFloat(LineTransactionTotal) + parseFloat(localState.noofTransactions)
                                    setTotalTrnasactionValue(LineTransactionTotal)
                                })
                                setrowsSummary(modifiedRowsSummary.length == undefined || modifiedRowsSummary.length == 0 ? [] : modifiedRowsSummary)



                                // localState.m_TBLCashBookPOSTrading.map((localState) => {
                                //     modifiedRowsPOSTrading.push({ paymentcode: localState.paymentCode, paymentDescription: localState.paymentDescription, amount: localState.amount })
                                //     LinePOSTradingAmount = parseFloat(LinePOSTradingAmount) + parseFloat(localState.amount)
                                //     setTotalPOSTrandingValue(LinePOSTradingAmount)
                                // })
                                // setrowsPOSTranding(modifiedRowsPOSTrading.length == undefined || modifiedRowsPOSTrading.length == 0 ? [{ id: 1 }] : modifiedRowsPOSTrading)


                                // localState.m_TBLCashBookPOSVouchers.map((localState) => {
                                //     modifiedRowsPOSVoucher.push({ paymentcode: localState.paymentCode, paymentDescription: localState.paymentDescription, amount: localState.amount })
                                //     LinePOSVoucherAmount = parseFloat(LinePOSVoucherAmount) + parseFloat(localState.amount)
                                //     setTotalPOSVoucherValue(LinePOSVoucherAmount)
                                // })
                                // setrowsPOSVoucher(modifiedRowsPOSVoucher.length == undefined || modifiedRowsPOSVoucher.length == 0 ? [{ id: 1 }] : modifiedRowsPOSVoucher)

                                localState.m_TBLCashBookVASCollection.map((localState) => {
                                    modifiedRowsVASCollection.push({ type: localState.type, provider: localState.provider, service: localState.service, paymentcode: localState.paymentCode, paymentDescription: localState.paymentDescription, amount: localState.amount })
                                    LineVASCollectionAmount = parseFloat(LineVASCollectionAmount) + parseFloat(localState.amount)
                                    setTotalVASValue(LineVASCollectionAmount)
                                })
                                setrowsVAS(modifiedRowsVASCollection.length == undefined || modifiedRowsVASCollection.length == 0 ? [] : modifiedRowsVASCollection)

                                localState.m_TBLCashbookReceipts.map((localState) => {
                                    modifiedRowsCashbookReceipts.push({ type: localState.type, account: localState.account, remark: localState.remark, paymentcode: localState.paymentCode, paymentDescription: localState.paymentDescription, amount: localState.amount })
                                    LineReceivedAmount = parseFloat(LineReceivedAmount) + parseFloat(localState.amount)
                                    setTotalReceiptsValue(LineReceivedAmount)
                                })
                                setrowsReceipts(modifiedRowsCashbookReceipts.length == undefined || modifiedRowsCashbookReceipts.length == 0 ? [] : modifiedRowsCashbookReceipts)

                                localState.m_TBLCashbookPayments.map((localState) => {
                                    modifiedRowsCashbookPayments.push({ type: localState.type, account: localState.account, remark: localState.remark, paymentcode: localState.paymentCode, paymentDescription: localState.paymentDescription, amount: localState.amount })
                                    LinePaymentAmount = parseFloat(LinePaymentAmount) + parseFloat(localState.amount)
                                    setTotalPaymentsValue(LinePaymentAmount)
                                })
                                setrowsPayment(modifiedRowsCashbookPayments.length == undefined || modifiedRowsCashbookPayments.length == 0 ? [] : modifiedRowsCashbookPayments)
                            })

                            setaddNew(false)

                            setDisabled(true)
                            setDisabledCode(true)
                            setSaveEnable(true)
                            setCrEnable(true)
                            SetDeleteEnable(true)
                            setSearchdisabled(true)
                            setReason("")
                            SetEditEnable(false)

                            return state
                        })
                    }
                } else if (responseData.success == false) {
                    if (nullCode == false) {
                        displayAlertMessage('success', "Record Not Found !")
                        setDisabledCode(true)
                        SetCode("")

                    }
                }
            }).catch(error => {
                SetLoadingAlert(false)
            })
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseData = await getCashBookData();
                const formattedData = responseData.map(item => {
                    return {
                        "label": item.cB_DESC,
                        "value": item.cB_NO,
                        "posNO": item.cB_POS
                    }
                });
                setCsbList(formattedData);
            } catch (error) {
                console.error("Error fetching cash book data:", error);
            }
        };

        fetchData();
    }, []);

    //Clear
    const ClearItem = () => {
        setErrorMsg("")
        setDisabledCode(false)
        setDisabled(false)
        setCrEnable(false)
        setSaveEnable(false)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        setReason("Created")
        SetEditEnable(false)
        setPermissionName("")
        setCashBookType("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setTotalPOSVoucherValue("0.0")
        setTotalVASValue("0.0")
        setTotalReceiptsValue("0.0")
        setTotalPaymentsValue("0.0")
        setTotalCreditSummaryValue("0.0")
        setTotalCreditSummaryValue("0.0")
        setTotalDebitSummaryValue("0.0")
        setTotalCFValue("0.0")
        setTotalOpenValue("0.0")
        setPayModeData([]);
        setReasonTypeData([])
        setPaymentsTypeData([])
        setHandleClear(prev => !prev)
        setHandleClear(!handleClear)
        toggleCustom("1")
        setrowsSummary([])
        setPaymentCode("")
        setCreditSummary([])
        setDebitSummary([])
        setrowsReceipts([])
        setrowsPayment([])
        setrowsVAS([])
    }

    //Toolbar Fucntions
    const handleNew = e => {
        // e.preventDefault()
        ClearItem();
        setaddNew(true)
        setShow(false)
        setSaveEnable(false)

    }

    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)
    }

    const handlesave = async (e) => {
        let objLogDet = JSON.parse(localStorage.getItem("authUser"))
        let user = objLogDet[2]
        let locCode = objLogDet[3]
        let comCode = objLogDet[5]

        // Extract the debit amount for 'Balance B/F' transaction
        const openingBalance = rowsDebitSummary.find(item => item.debitTransaction === 'Balance B/F');
        const TotalOpenValue = openingBalance ? parseFloat(openingBalance.debitamount) : 0.0;

        if (rowsSummary.length != 0) {
            for (let i = 0; i < rowsSummary.length; i++) {
                if (rowsSummary[i].state == false) {
                    displayAlertMessage('danger', `Please select ${rowsSummary[i].paymentDescription}`)
                    return
                }
            }
        }


        let data = JSON.stringify({
            "HED_TYPE": 'CSB',
            "HED_RUNNO": DocumentCode,
            "HED_COMCODE": LogCompanyCode,
            "HED_SETUPLOC": locCode,
            "HED_TXNDATE": CashBookDate,
            "HED_TIME": new Date(),
            "HED_PROCDATE": new Date(),
            "HED_LOCATION": locCode,
            // "HED_OPEAMT": parseFloat(TotalOpenValue),
            "HED_OPEAMT": TotalOpenValue,
            "HED_DEBAMT": parseFloat(TotalDebitSummaryValue),
            "HED_CREAMT": parseFloat(TotalCreditSummaryValue),
            "HED_CLOAMT": parseFloat(TotalCFValue),
            "HED_CRBY": LogUserType,
            "HED_EXPBATCH": "1",
            "HED_PRINTCOUNT": parseFloat(0),
            "HED_EXPORT": 0,
            "MenuCode": menuCode,
            "LoggedCompany": LogCompanyCode,
            "LoggedLocation": LocationCode,
            "Reason": Reason,
            "cshbookCode": cashBookType,
        })

        try {
            SetLoadingAlert(true);
            SetLoadingAlerttitle("Saving...");

            const response = await saveCashBook(data);

            if (response.success) {
                displayAlertMessage('success', response.message);
                setLastCashBookDocumentCode(response.data);
                ClearItem();
            } else {
                displayAlertMessage('danger', response.message);
            }
        } catch (error) {
            console.error("Error saving cash book:", error);
            displayAlertMessage('danger', 'An error occurred while saving the cash book.');
        } finally {
            SetLoadingAlert(false);
        }
    }

    async function handlePrint(option) {

        if (lastCashBookDocumentCode == "") {
            displayAlertMessage('danger', "Please do cash book entry first")
            return
        }

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const authToken = localStorage.getItem("authToken")
        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/CashBook/report/${LogUserType}/${lastCashBookDocumentCode}/${LocationCode}/${option == "PDF" ? 1 : 0}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            }
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (option == "PDF") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                    }
                    if (option == "XCEL") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
                    }
                }
                SetLoadingAlert(false)
            }).catch(error => {
                console.log(error.message)
                SetLoadingAlert(false)
            })
    }



    //functon for Tab navigation
    const [customActiveTab, setcustomActiveTab] = useState("1")
    const toggleCustom = tab => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab)
        }
    }

    const handleRowClick = async (paymentcode) => {

        try {
            SetLoadingAlert(true);
            SetLoadingAlerttitle("Fetching...");
            setPaymentCode(paymentcode);
            const fiterSelectedRow = rowsSummary.find(row => row.paymentcode === paymentcode);
            const response = await PayModetData(paymentcode, cashBookType, LocationCode);

            if (response.success) {
                const data = response.data.map((item, index) => {
                    item.id = index
                    item.state = fiterSelectedRow.state ? fiterSelectedRow.state : false;
                    return item;
                });
                setPayModeData(data);
                setcustomActiveTab("2");
            } else {
                console.error("Error fetching data");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            SetLoadingAlert(false);
        }

    };


    const handleRowClickReceipts = async (type) => {

        setReasonTypeReceiptsCode(type);
        const fiterSelectedRow = rowsReceipts.find(row => row.type === type);
        const response = await ReasonTypeReceiptsData(type, cashBookType, LocationCode);

        if (response.success) {
            const data = response.data.map((item, index) => {
                item.id = index
                item.state = fiterSelectedRow.state ? fiterSelectedRow.state : false;
                return item;
            });
            setReasonTypeData(data);
        } else {
            console.error("Error fetching data");
        }
    };


    const handleRowClickPayments = async (type) => {

        setReasonTypePaymentCode(type);
        const fiterSelectedRow = rowsPayment.find(row => row.type === type);
        const response = await ReasonTypePaymentsData(type, cashBookType, LocationCode);

        if (response.success) {
            const data = response.data.map((item, index) => {
                item.id = index
                item.state = fiterSelectedRow.state ? fiterSelectedRow.state : false;
                return item;
            });
            setPaymentsTypeData(data);
        } else {
            console.error("Error fetching data");
        }
    };

    //**Permission Check */
    const permission = (operation) => {
        const authToken = localStorage.getItem("authToken")
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {

                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "PDF") {
                            if (Print == true) {
                                handlePrint("PDF")
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        } else if (operation == "XCEL") {
                            if (Print == true) {
                                handlePrint("XCEL")
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }


    //Function for displaying Alert Messages.S
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setAlertShow(true)

        setTimeout(() => {
            setAlertShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }


    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumbs title={parentName} breadcrumbItem={menuName} />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPAlert
                                        confirm_both={sweetAlertShow}
                                        title={menuName}
                                        description={AlertDescription}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        onConfirm={() => {
                                            setsweetAlertShow(false)
                                            if (AlertConfirmOption == 1) {

                                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }

                                            } else if (AlertConfirmOption == 2) {
                                                handleEdit()
                                            } else if (AlertConfirmOption == 3) {
                                                history.push('/dashboard')
                                            } else if (AlertConfirmOption == 4) {
                                                handleNew()
                                            } else if (AlertConfirmOption == 5) {

                                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                                    handleDelete()
                                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                                } else {
                                                    setReason("")
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 6) {
                                                if (menuPrint == true && permissionReasonShow == false) {
                                                    setprintoptionShow(true)
                                                } else if (menuPrint == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            }
                                        }}
                                        onCancel={() => {
                                            setsweetAlertShow(false)
                                            clearPermissionInputs()
                                        }}
                                    />
                                    <DPPermission
                                        confirm_both={permissionAlertShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        AlName={permissionName}
                                        AlNameOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setPermissionName(val2)
                                        }}
                                        AlPassward={permissionPassword}
                                        AlPasswardOnchange={e => {
                                            let val2 = Text(e.target, 50, true, true, "any", true)
                                            setPermissionPassword(val2)
                                        }}
                                        AlReason={Reason}
                                        AlReasonOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setReason(val2)
                                        }}
                                        onConfirm={() => {
                                            setPermissionAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                permission("Save")
                                            } else if (AlertConfirmOption == 5) {
                                                permission("Delete")
                                            } else if (AlertConfirmOption == 6) {
                                                setprintoptionShow(true)
                                            }
                                        }}
                                        onCancel={() => {
                                            setPermissionAlertShow(false)
                                            clearPermissionInputs()
                                        }}
                                    />
                                    <DPPrintOption
                                        confirm_both={printoptionShow}
                                        title={menuName}
                                        showCancel={true}
                                        cancelColor={"danger"}
                                        onConfirmpdf={() => {
                                            handlePrint("PDF")
                                            setprintoptionShow(false)
                                        }}
                                        onConfirmxcel={() => {
                                            handlePrint("XCEL")
                                            setprintoptionShow(false)
                                        }}
                                        onCancel={() => {
                                            setprintoptionShow(false)
                                        }}
                                    />
                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={false}
                                        helpClick={() => {
                                            alert("Help")
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            handleNew,
                                                setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveBtnEnable}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        //Print Button
                                        printEnable={true}
                                        printClick={() => {
                                            setAlertDescription("Do you wish to Print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <DPNavBar
                                        buttons={tabList}
                                        activeStatus={customActiveTab}
                                    />
                                    {AlertShow ? (
                                        <Alert color={AlertColor} role="alert">
                                            {AlertMsg}
                                        </Alert>
                                    ) : null}
                                    <TabContent
                                        activeTab={customActiveTab}
                                        className="p-3 text">
                                        <TabPane tabId="1">
                                            <CashBookSummary
                                                DataRow={rowsSummary}
                                                setrowsSummary={setrowsSummary}
                                                Disabled={true}
                                                TotalSummaryValue={TotalSummaryValue}
                                                TotalTrnasactionValue={TotalTrnasactionValue}
                                                handleRowClick={handleRowClick}
                                                handleClear={handleClear}
                                                csbList={csbList}
                                                setCashBookType={setCashBookType}
                                                cashBookType={cashBookType}
                                                SetCashBookSummary={SetCashBookSummary}
                                            ></CashBookSummary>
                                        </TabPane>
                                        <TabPane tabId="2">
                                            <CashBookPOSTrading
                                                DataRow={rowsPOSTranding}
                                                setrowsPOSTranding={setrowsPOSTranding}
                                                Disabled={true}
                                                TotalPOSTrandingValue={TotalPOSTrandingValue}
                                                PayModeData={PayModeData}
                                                setPayModeData={setPayModeData}
                                                handleClear={handleClear}
                                                cashBookType={cashBookType}
                                                csbList={csbList}
                                                paymentCode={paymentCode}
                                                setrowsSummary={setrowsSummary}
                                                rowsSummary={rowsSummary}
                                            ></CashBookPOSTrading>

                                        </TabPane>
                                        <TabPane tabId="3">
                                            <CashBookPOSVouchers
                                                DataRow={rowsPOSVoucher}
                                                Disabled={true}
                                                TotalPOSVoucherValue={TotalPOSVoucherValue}
                                                handleClear={handleClear}
                                            ></CashBookPOSVouchers>

                                        </TabPane>
                                        <TabPane tabId="4">
                                            <CashBookVASCollection
                                                DataRow={rowsVAS}
                                                Disabled={true}
                                                TotalVASValue={TotalVASValue}
                                                handleClear={handleClear}
                                            ></CashBookVASCollection>
                                        </TabPane>
                                        <TabPane tabId="5">
                                            <CashBookReceipts
                                                DataRow={rowsReceipts}
                                                Disabled={true}
                                                TotalReceiptsValue={TotalReceiptsValue}
                                                handleClear={handleClear}
                                                handleRowClickReceipts={handleRowClickReceipts}
                                                reasonTypeReceiptsCode={reasonTypeReceiptsCode}
                                                ReasonTypeData={ReasonTypeData}
                                                setReasonTypeData={setReasonTypeData}
                                            ></CashBookReceipts>
                                        </TabPane>
                                        <TabPane tabId="6">
                                            <CashBookPayments
                                                DataRow={rowsPayment}
                                                Disabled={true}
                                                TotalPaymentsValue={TotalPaymentsValue}
                                                handleClear={handleClear}
                                                handleRowClickPayments={handleRowClickPayments}
                                                reasonTypePaymentCode={reasonTypePaymentCode}
                                                PaymentsTypeData={PaymentsTypeData}
                                                setPaymentsTypeData={setPaymentsTypeData}
                                            ></CashBookPayments>
                                        </TabPane>
                                        <TabPane tabId="7">
                                            <CashbookCreditDebit
                                                Disabled={true}
                                                LocationCode={LocationCode}
                                                //CashBookDate={CashBookDate + '  -  ' + currentDate}
                                                CashBookDate={CashBookDate + '  -  ' + cutoffDate}
                                                rowsCreditSummary={rowsCreditSummary}
                                                rowsDebitSummary={rowsDebitSummary}
                                                TotalCreditSummaryValue={TotalCreditSummaryValue}
                                                TotalDebitSummaryValue={TotalDebitSummaryValue}
                                                TotalCFValue={TotalCFValue}
                                                handleClear={handleClear}
                                            ></CashbookCreditDebit>

                                        </TabPane>
                                    </TabContent>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}
export default CashBook